<template>
  <section id="shop" ref="shopContent">
    <PageTitle :title="$t('shop.products.activities-title')" :breadcrumbs="breadcrumbs"></PageTitle>
    
    <div class="wrapper wrapper-content animated fadeInRight">

      <Header></Header>

      <div class="row" v-if="selectedShop">
        <div class="col">
          <ListCategories mode="ACTIVITY"></ListCategories>
        </div>
      </div>

      <div class="row" v-if="selectedShop">
        <div class="col">
          <ListProducts mode="ACTIVITY"></ListProducts>
        </div>
      </div>

      <div class="row" v-if="selectedShop">
        <div class="col">
          <ListAvailabilities></ListAvailabilities>
        </div>
      </div>

      <div class="row" v-if="selectedShop">
        <div class="col">
          <ListOrderedActivities></ListOrderedActivities>
        </div>
      </div>

    </div>
  </section>
</template>


<script lang="ts">
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';

import PageTitle from '@root/src/client/components/panels/PageTitle.vue';
import { enableIbox, disableIbox} from '@root/src/client/theme/inspinia-jquery'; 

import { useShopAdmin } from '../../composables/useShopAdmin';

import Header from '../panels/Header.vue';

import ListProducts from '../panels/products/products/ListProducts.vue';
import ListCategories from '../panels/products/categories/ListCategories.vue';
import ListAvailabilities from '../panels/availabilities/ListAvailabilities.vue'
import ListOrderedActivities from '../panels/ListOrderedActivities.vue'


@Component({
  components: {
    PageTitle,
    ListProducts,
    ListCategories,
    ListAvailabilities,
    ListOrderedActivities,
    Header
  }
})
export default class Products extends mixins(GenericPage) {

  setup(props:any, context:any) {
    const { shops, selectedShop } = useShopAdmin(props, context);
    return { shops, selectedShop }
  }

  get breadcrumbs() {
    return [{
      label: this.$t('home.dashboard')
    },
    {
      label: this.$t('shop.title')
    }]
  }

  mounted() {
    enableIbox(this.$refs.shopContent as HTMLElement);
  }

  beforeDestroy() {
    disableIbox(this.$refs.shopContent as HTMLElement);
  }

}
</script>